import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

interface LegacyBillingRedirectProps {
  path?: 'claim' | 'encounter';
  suffix?: string;
}

export const LegacyBillingRedirect: React.FC<LegacyBillingRedirectProps> = ({
  path,
  suffix = '',
}) => {
  const params = useParams();
  const location = useLocation();
  const id = path === 'claim' ? params.claimId : params.encounterId;
  return (
    <Navigate
      to={{
        pathname: path ? `/jotbill/${path}/${id}${suffix}` : '/jotbill',
        search: location.search,
        hash: location.hash,
      }}
      state={location.state as unknown}
      replace
    />
  );
};
